<script module>
  export { default as layout } from '@layouts/authentication-layout.svelte'
</script>

<svelte:head>
  <title>Sign In</title>
</svelte:head>

<script>
  import Form from '@components/forms'
  import Button from '@components/buttons/button.svelte'
  import CtaButton from '@components/buttons/cta-button.svelte'
  import Message from '@components/general/message.svelte'
  import { Link, useForm } from '@inertiajs/svelte'
  import { ArrowRight } from 'lucide-svelte'
  import Logo from '@assets/images/altruist-vertical-logo.svg'

  const form = useForm({
    email_address: '',
    password: '',
  })

  let unconfirmedError = $derived(Object.keys($form.errors).includes("unconfirmed"))
  let showErrors = $derived(!unconfirmedError || Object.keys($form.errors).length > 1)

  function handleSubmit(e) {
    e.preventDefault()
    $form.post('/session')
  }
</script>

<div class="flex min-h-0 flex-1 flex-col">
  <div class="flex flex-1 flex-col justify-center">
   
    <!-- Logo -->
    <div class="flex justify-center mb-10">
      <img src={Logo} alt="Altruist" class="w-28" />
    </div>

    <!-- Heading -->
    <h1 class="text-[34px] text-gray-700 font-serif text-center mb-6">Welcome, sign in below</h1>

    <Form.Element class="auth-form" {form} id="session-form" onsubmit={handleSubmit} {showErrors} allowEnterSubmit>

    {#if unconfirmedError}
      <Message type="info">
        <p>Please confirm your email address by clicking the link in the email we sent you.</p>
        <Button variant="naked" path="/user_confirmation/new" text="Resend confirmation email" class="mt-2 text-sm text-yellow-700 hover:text-primary-700 underline text-smaller" Icon={ArrowRight} />
      </Message>
    {/if}

    <Form.Items class="gap-6">

      <!-- Email Address -->
      <Form.Item name="email_address" label="Email Address *" type="email"
        bind:value={$form.email_address}
        placeholder="your-email@company.com"
        validate={false}
        required />

      <!-- Password -->
      <Form.Item name="password" type="password"
        bind:value={$form.password}
        placeholder="********"
        validate={false}
        required>
        {#snippet labelContent({ baseClass })}
          <div class="flex items-center justify-between">
            <label for="password" class={baseClass}>Password *</label>
            <Button variant="naked" path="/passwords/new" text="Forgot password?" class="text-gray-500/80 underline hover:underline hover:text-gray-700 text-smaller" tabindex={-1} />
          </div>
        {/snippet}
      </Form.Item>

    </Form.Items>

    <!-- Submit -->
    <CtaButton
      type="submit"
      size="lg"
      text="Log In"
      loading={$form.processing}
      class="w-full justify-center mt-8 py-3 h-auto rounded-lg text-base"
    />

    </Form.Element>
  </div>

  <div class="pt-4 text-center text-sm text-gray-700">
    Not a member yet?
    <Link href="/users/new" class="text-gray-700 hover:text-primary-700 no-underline border-b-2 border-primary-500">Register here</Link>.
  </div>

</div>